/**
 * Registry of intentionally planned routes that should render Coming Soon
 * instead of falling through to the global 404 page.
 *
 * Add a new entry here and a matching <Route> in App.js when a future module
 * needs a public placeholder.
 */
export const COMING_SOON_PAGES = {
  welcome: {
    path: "welcome",
    featureName: "Welcome",
    title: "Something Exciting is Coming Soon",
    description:
      "We're working hard to launch this feature. Stay tuned for upcoming updates.",
    seo: {
      title: "Coming Soon | Trocanet",
      description:
        "This feature is currently under development and will be available soon.",
      canonicalPath: "/welcome",
    },
  },
};

export const getComingSoonConfig = (key) => COMING_SOON_PAGES[key] || null;
